module.exports = __webpack_public_path__ + "static/media/galleryImg6.80f9a188.jpg";